import { motion } from "framer-motion";
import { Reveal, staggerContainer, staggerItem } from "./Reveal";
import { Icon } from "./Icon";
import { AmbientOrbs } from "./Ambient";
import { FEATURES } from "@/lib/data";

export const WhyUs = () => (
  <section id="why" className="relative overflow-hidden bg-white py-16 md:py-20" data-testid="why-section">
    <AmbientOrbs />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <span className="inline-flex items-center rounded-full border border-emerald2-300/40 bg-emerald2-500/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-emerald2-600">
            Why Biz360 Compliance
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-navy-900 md:text-4xl lg:text-5xl">
            Your Trusted Partner for Business Growth &amp; Compliance
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-base leading-relaxed text-slate-600 md:text-lg">
            One platform for business registration, taxation, compliance, accounting and
            advisory—powered by experienced professionals, smart technology and responsive
            support.
          </p>
        </Reveal>
      </div>

      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, margin: "-60px" }}
        className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4"
      >
        {FEATURES.map((f, i) => {
          const green = i % 2 !== 0;
          return (
            <motion.div
              key={f.title}
              variants={staggerItem}
              className={`group relative rounded-3xl border border-slate-200 bg-white p-7 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(15,30,60,0.1)] ${
                green ? "hover:border-emerald2-300" : "hover:border-gold-300"
              }`}
              data-testid={`feature-card-${i}`}
            >
              <motion.span
                animate={{ y: [0, -5, 0] }}
                transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut", delay: i * 0.15 }}
                className={`grid h-12 w-12 place-items-center rounded-2xl transition-colors duration-300 ${
                  green
                    ? "bg-emerald2-500/10 text-emerald2-600 group-hover:bg-emerald2-500 group-hover:text-white"
                    : "bg-gold-500/12 text-gold-600 group-hover:bg-gold-500 group-hover:text-navy-950"
                }`}
              >
                <Icon name={f.icon} className="h-6 w-6" />
              </motion.span>
              <h3 className="mt-5 text-lg font-semibold text-navy-900">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{f.desc}</p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);
